<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background: new 0 0 512 512"
    xml:space="preserve"
    :width="size"
    :height="size"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M128,0v384H0l160,128l160-128H192V0H128z M256,0v64h256V0H256z M256,128v64h192v-64H256z M256,256v64h128v-64H256z"
      />
    </g>
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconDESC extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconDESC;
</script>
